/*global google*/
import React from 'react'
import Container from '../wrapper/Container'
import {Tabs, Tab,} from 'material-ui/Tabs'
import TextField from 'material-ui/TextField';
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import FontIcon from 'material-ui/FontIcon';

import {css} from 'glamor'
import {myConfig} from '../config/myConfig'
import PlacesAutocomplete, {geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import Loader from './Loader'
import MonthView from './MonthView'
import TodayView from './TodayView'
import RaisedButton from 'material-ui/RaisedButton'

import FlatButton from 'material-ui/FlatButton'
import Snackbar from 'material-ui/Snackbar'

import DialogPlaces from './DialogPlaces'



import moment from 'moment'
const styles = {}
const isXS = window.innerWidth < 767


class Main extends React.Component {

  state = {
    tab: 'TodayView',
    loading:true,
    msgLoading:'',

    openSnackbar:false,
    msgSnackbar:'',

    place : {
      city: '',
      latitude : '',
      longitude :'',
    },

    dataTodayView: {},
    dataMonthView : {},

    monthSelected:Number(moment(new Date()).format('M')),
    yearSelected:Number(moment(new Date()).format('YYYY')),

    // NEW DATA
    openModal:false

  }

  componentDidMount() {
    this.getMyLocation()
  }

  // handleChange = value=> {
  //   this.setState({ tab: value })
  //
  //
  //   if ( value === 'MonthView' ) {
  //     if (!this.state.place) {
  //       alert('attention pas place')
  //       return false
  //     }
  //
  //     let ISMonthData = JSON.parse(localStorage.getItem('ISMonthData'))
  //
  //     if (ISMonthData) {
  //       if ( ISMonthData.requested_at !== null || (typeof(ISMonthData.requested_at ) !== "undefined" ) &&
  //         ( ISMonthData.requested_at.split('/')[2].split(' ')[0] === moment(new Date()).format('YYYY') &&
  //         ISMonthData.requested_at.split('/')[1] === moment(new Date()).format('MM') ) ){
  //         this.setState({
  //           dataMonthView:ISMonthData,
  //           loading:false,
  //           openSnackbar:true,
  //           msgSnackbar:'Les données du mois ont été récupérées !'})
  //       } else {
  //         this.callApiMonth(this.state.place)
  //       }
  //     }
  //     else {
  //       this.callApiMonth(this.state.place)
  //     }
  //   }else{
  //       //this.callApiToday(this.state.place)
  //   }
  // }

  // modification : retrait du localstorage du mois
  handleChange = value=> {
    this.setState({ tab: value })

    if ( value === 'MonthView' ) {
      if (!this.state.place) {
        alert('attention pas place')
        return false
      }
      this.callApiMonth(this.state.place)

    } else {
      //this.callApiToday(this.state.place)
    }
  }

  prevMonth = () =>{
    const {monthSelected,yearSelected} = this.state
    this.setState({
      monthSelected:monthSelected===1 ? 12 : monthSelected-1,
      yearSelected:monthSelected===1 ? yearSelected-1 : yearSelected
      },
      ()=>this.callApiMonth(JSON.parse(localStorage.getItem('ISPlace')))
    )
  }
  nextMonth = () =>{
    const {monthSelected,yearSelected} = this.state
    this.setState({
      monthSelected:monthSelected===12 ? 1 : Number(monthSelected)+1,
      yearSelected:monthSelected===12 ? Number(yearSelected)+1 : yearSelected
      },
      ()=>this.callApiMonth(JSON.parse(localStorage.getItem('ISPlace')))
    )
  }

  //onChange = cityInput => this.setState({cityInput})




  setPlace =(place)=>{
    this.setState({
      place,
      openModal:false
    })
    localStorage.setItem('ISPlace',JSON.stringify(place))
    if (this.state.tab === 'TodayView') this.callApiToday(place)
    if (this.state.tab === 'MonthView') this.callApiMonth(place)
  }


  closeModal=()=> this.setState({openModal:false})



  callApiToday = (place)=>{
    console.log('callApiToday : Start')
    this.setState({loading:true})


    let timestamp = (new Date().getTime() / 1000).toFixed(0)
    const url = `https://api.institutsounnah.net/prayer-times?latitude=${place.lat}&longitude=${place.lng}&timestamp=${timestamp}`

    fetch(url).then( response => response.json() )
      .then(json => {
        console.log(json);
        this.setState({dataTodayView:json,loading:false,})
        localStorage.setItem('ISTodayData',JSON.stringify(json))

      })
      .catch(error => console.log(error) )
  }


  callApiMonth = (place)=> {
    console.log('callApiMonth : Start')
    this.setState({loading:true})

    const url = `https://api.institutsounnah.net/monthly-prayer-times?latitude=${place.lat}&longitude=${place.lng}&month=${this.state.monthSelected}&year=${this.state.yearSelected}`
    fetch(url).then( response => response.json() )
      .then(json => {
        this.setState({dataMonthView:json,loading:false})
        console.log(json);
        if ( (this.state.monthSelected === Number(moment(new Date()).format('M')) )
        && (this.state.yearSelected === Number(moment(new Date()).format('YYYY')) ) )
          localStorage.setItem('ISMonthData',JSON.stringify(json))
      })
      .catch(error => console.log(error) )
  }





  getMyLocation = () =>{
    console.log('getMyLocation : Start')
    this.setState({loading:true})

    if (localStorage.getItem('ISPlace') ){
      console.log('getMyLocation - localStorage getItem : done')

      let place = JSON.parse(localStorage.getItem('ISPlace'))
      let ISTodayData = JSON.parse(localStorage.getItem('ISTodayData'))
      //let ISMonthData = JSON.parse(localStorage.getItem('ISMonthData'))

      this.setState({ place })


      if (ISTodayData && (ISTodayData.requested_at.split(' ')[0]=== moment(new Date()).format('DD/MM/YYYY') )) {
        this.setState({
          dataTodayView:ISTodayData,
          loading:false,
          openSnackbar:true,
          msgSnackbar:'Les données du jour ont été récupérées !'})
      } else {
        this.callApiToday(place)
      }

      // if (ISMonthData.requested_at &&
      //   ( ISMonthData.requested_at.split('/')[2].split(' ')[0] === moment(new Date()).format('YYYY')  &&
      //   ISMonthData.requested_at.split('/')[1] === moment(new Date()).format('MM') ) ){
      //   this.setState({
      //     dataMonthView:ISMonthData,
      //     loading:false,
      //     openSnackbar:true,
      //     msgSnackbar:'Les données du mois ont été récupérées !'})
      // } else{
      //   this.callApiMonth(place)
      // }



    } else{
      this.setState({openModal:true})
    }

  }


  generatePdf = ()=>{
    const input = document.getElementById('pdf');
    html2canvas(input,{
    windowWidth : document.getElementById('pdf').offsetWidth,
    windowHeight: 821,
    width:1400,
    height:1000,
    scale: 1,
    x:0,
    y:0,
    //windowHeight: element.scrollHeight
  })
    .then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();

     pdf.addImage(imgData, 'PNG', 0, 0);
     pdf.text('Horaires de prière générés sur https://horaires.institutsounnah.com/', 10, 10)
     pdf.save("horairespriere.pdf");
    })
    ;
  }

  render() {
    return (

      <Container
        adjustHeight
        containerOutStyle={{height:'100%'}}
        containerInStyle={{minHeight:window.innerHeight-80-30,paddingBottom:20}}>


        <DialogPlaces setPlace={this.setPlace} openModal={this.state.openModal} closeModal={this.closeModal}/>

        <div style={{
          minHeight:'85px',
          boxSizing:'border-box',
          width:'100%',
          padding:'5px 10px 10px 10px',
          marginTop:30,
          position:'relative',
          textAlign:'right',
          backgroundColor:myConfig.blueLight,
          borderTopRightRadius:2,
          borderTopLeftRadius:2,
          color:'white' ,display:'flex',justifyContent:'space-between',alignItems:'flex-end',flexDirection:'column'}}>

            <img
              {...css({height:'90px',left:-8,top:-30,position:'absolute',borderRadius:'50%',border:'4px solid white','@media(max-width: 767px)':{height:60}})}
              src='/img/logo.jpg' alt='logo-InstitutSounnah' />


            <h2 {...css({fontWeight:'normal',margin:0,padding:0,'@media(max-width: 767px)':{fontSize:16,marginLeft:60}})}>Horaires de prières à{isXS && <br/>} {this.state.place.name}</h2>
            {/* <span style={{marginRight:5}}> [{Number(this.state.latitude).toFixed(2)},{Number(this.state.longitude).toFixed(2)}]</span> */}

            <div style={{display:'flex',justifyContent:'space-between'}}>
            {this.state.tab === 'MonthView' &&
            <FlatButton
            label="Télécharger les horaires"
            style={{float:'left',marginTop:30}}
            primary={true}
            onClick={()=>this.generatePdf()}
            > <FontIcon style={{paddingTop:5,paddingLeft:10,height:18,width:18}}color='rgb(36, 109, 177)'className="fas fa-file-pdf" /></FlatButton>}


            <FlatButton
              label="Changer de ville"
              style={{float:'right',marginTop:30}}
              primary={true}
              onClick={()=>this.setState({openModal:true})}
              > <FontIcon style={{paddingTop:5,paddingLeft:10,height:18,width:18}}color='rgb(36, 109, 177)'className="fas fa-map-marker-alt" /></FlatButton>

                </div>

          </div>





        <Tabs
          value={this.state.value}
          onChange={this.handleChange}
          tabItemContainerStyle={{height:40}}>
          <Tab
            label="Horaires du jour"
            value="TodayView"
            buttonStyle={{height:40}}>


            {this.state.tab === 'TodayView' ?
              this.state.loading ? <Loader msg={this.state.msgLoading}/> :
                <div>
                  <div style={{height:50,boxSizing:'border-box',marginTop:10,display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
                    <p {...styles.dateTitle}>{this.state.dataTodayView.today+' '+this.state.dataTodayView.gregorian_date}</p>
                    <p {...styles.dateTitle}>{this.state.dataTodayView.hijri_date}</p>
                  </div>
                  <TodayView dataTodayView={this.state.dataTodayView}/>
                </div>: null
            }


          </Tab>
          <Tab
            label="Horaires du mois"
            value="MonthView"
            buttonStyle={{height:40}}>


            {this.state.tab === 'MonthView' &&
              <div style={{height:50,boxSizing:'border-box',width:'100%',marginTop:10,display:'flex',color:myConfig.blue,justifyContent:'space-around',alignItems:'center'}}>
                <p {...css({cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center','@media(max-width: 767px)':{fontSize:12}})} onClick={()=>this.prevMonth()}> <i className='fa fa-arrow-alt-circle-left'/><span>mois précedent</span></p>

                <p {...styles.dateTitle}>{moment(this.state.monthSelected, 'M').format('MMMM')} {this.state.yearSelected}</p>

                <p {...css({cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center','@media(max-width: 767px)':{fontSize:12}})} onClick={()=>this.nextMonth()} ><i className='fa fa-arrow-alt-circle-right'/> <span>mois suivant</span></p>
              </div>
            }
            {this.state.tab === 'MonthView' ?
              this.state.loading || typeof this.state.dataMonthView.dates === 'undefined' ? <Loader msg={this.state.msgLoading}/> :
                <MonthView dataMonthView={this.state.dataMonthView}/>
              : null }



          </Tab>
        </Tabs>

        <Snackbar
          open={this.state.openSnackbar}
          message={this.state.msgSnackbar}
          autoHideDuration={4000}
          onRequestClose={()=>this.setState({openSnackbar: false,msgSnackbar:''})} />
      </Container>
    )
  }
}

styles.dateTitle = css({
  fontSize:22,
  fontWeight:'normal',
  color:myConfig.blue
})

styles.containerRowTime = css({
})



export default Main



// WEBPACK FOOTER //
// ./src/components/Main.jsx